import useSWR from 'swr';
import { hesselApiTypes } from '../../../lib/api/models/hessel-api';
import { generateQueryString } from '../../../lib/api/helpers';

type CarFinancingParams = {
    LeasingPackageId: string;
    DurationMonths: number;
    KilometersPerYear: number;
    DownPayment: number;
    ResidualValue: number;
    InsuranceServiceId?: string;
};

type UseLeaseManagerReturnType = {
    leaseManagerFinancing: hesselApiTypes.LeaseManagerFinancing | undefined;
    error: unknown;
    isLoading: boolean;
    isValidating: boolean;
};

/**
 *
 * @param params
 * @param active true for requests to be sent
 * @returns
 */
export const useLeaseManager = (params: CarFinancingParams, active?: boolean): UseLeaseManagerReturnType => {
    const { data, error, isLoading, isValidating } = useSWR<hesselApiTypes.LeaseManagerFinancing>(
        active ? `/api/v1/Leasing/LeasingCalculation?${generateQueryString(params)}` : null,
        {
            revalidateOnFocus: false,
            revalidateIfStale: false,
        }
    );

    return { leaseManagerFinancing: data, error, isLoading, isValidating };
};
